
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';
import { createSlice, Dispatch } from '@reduxjs/toolkit';
// utils
import axios2 from 'axios';
import axios from '../../utils/axios';
// import axios2 from '../../utils/axios2';
import { CustomFile } from '../../components/upload';
import { getAccessToken,getAccessTokenWithRefreshed } from '../../auth/utils';

import {
    IUserSettingsState,
    IUserGeneralInput,
    IUserSocialLinkInput,
    IUserChangePasswordInput,
    IUserNotifInput,
} from '../../@types/user';



const initialState: IUserSettingsState = {
    isLoading: false,
    updatedUser: null,
    error: null,
    // userGeneral: null,
    // userNotif: null,
    // userSocialLink: null,
    // userChangePassword: null,

};



const slice = createSlice({
    name: 'userrSettings',
    initialState,
    reducers: {
        // resetState(state) {
        //     // // console.log(`reset(state);`);
        //      // console.log(`reset(state);`);
        //     // console.log(`initialState`)
        //     console.log(initialState)
        //     state = initialState;
        //      // console.log(`state`)
        //     console.log(state)
        // },
        resetState: () => initialState,
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
            state.error = null;
        },

        stopLoading(state) {
            state.isLoading = true;
            state.error = null;
        },

        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
            state.isLoading = false;
        },


        // getUserGeneralSuccess(state, action) {
        //     state.isLoading = false;
        //     state.userGeneral = action.payload;
        // },


        updateUserGeneralSuccess(state, action) {
            state.isLoading = false;
            state.updatedUser = action.payload;
        },




        // getUserNotifSuccess(state, action) {
        //     state.isLoading = false;
        //     state.userNotif = action.payload;
        // },

        updateUserNotifSuccess(state, action) {
            state.isLoading = false;
            state.updatedUser = action.payload;
        },


        // getUserSocialLinkSuccess(state, action) {
        //     state.isLoading = false;
        //     state.userSocialLink = action.payload;
        // },

        updateUserSocialLinkSuccess(state, action) {
            state.isLoading = false;
            state.updatedUser = action.payload;
        },

        updateUserPasswordSuccess(state, action) {
            state.isLoading = false;
            state.updatedUser = action.payload;
            // state.userChangePassword = null;
        },



    }
});



// Reducer
export default slice.reducer;


export const {
    // resetState,
    startLoading,
    stopLoading,
    hasError,
    // getUserGeneralSuccess,
    updateUserGeneralSuccess,
    // getUserNotifSuccess,
    updateUserNotifSuccess,
    // getUserSocialLinkSuccess,
    updateUserSocialLinkSuccess,
    updateUserPasswordSuccess,
} = slice.actions;











export function resetState() {
    // console.log("Reset State")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetState());
    }

}




function isFile(input: any): boolean {
    if ('File' in window && input instanceof File)
        return true;

    return false;
}

// function formatBytes(bytes: number, decimals = 2) {
//     if (!+bytes) return '0 Bytes'

//     const k = 1024
//     const dm = decimals < 0 ? 0 : decimals
//     const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

//     const i = Math.floor(Math.log(bytes) / Math.log(k))

//     return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`
// }

export function updateUserGeneral(input: IUserGeneralInput) {
    // console.log(`Update User General`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());


        try {
            const accessToken = await getAccessTokenWithRefreshed();

            if (!accessToken)
                throw new Error("Access token not available");


            // const _file = input.photoURL.name;
            // const _file = input.photoURL.size;
            // const _file = input.photoURL.type;

            // console.log(_file)


            // console.log(input);

            // const fileDetail = JSON.stringify(input.photoURL);


            // console.log(fileDetail);

            // console.log(input.photoURL?.valueOf())
            // console.log(input.photoURL?.valueOf())
            // console.log(input.photoURL?.valueOf())
            // if(input.photoURL typeof CustomFile){

            // }


            const _file = input.photoURL;
            // const _uploadfile = input.uploadFileInfo;

            // const isInputFile = isFile(_file);

            // console.log(_file)
            // console.log(_uploadfile)



            if (_file instanceof Blob) {
                // console.log("Input file")
                // const photoFile = Object.getPrototypeOf(_file)
                // console.log(photoFile);


                const bucketType = 'profile';
                const fileName = _file.name;
                const fileSize = _file.size.toString();
                const fileType = _file.type;


                const getUploadURLResponse = await axios.post('/get-upload-url', {
                    // accessToken,
                    bucketType,
                    fileName,
                    fileSize,
                    fileType,
                });

                const signedUrl = getUploadURLResponse.data.signedUrl;
                const _photoUrl = getUploadURLResponse.data.photoUrl;
                if (signedUrl) {
                    const uploadFileResponse = await axios2.put(
                        signedUrl,
                        _file,
                        { headers: { 'Content-Type': fileType, }, },
                    );
                    // console.log(uploadFileResponse);
                    if (uploadFileResponse.status === 200) {
                        input.photoURL = _photoUrl;
                    } else {
                        input.photoURL = '';
                    }
                }
                // console.log(getUploadURLResponse);
            }
            // throw new Error(`${accessToken}`);
            const response = await axios.post('/user-setting', {
                ...input,
                accessToken,
                type: "general"
            });

            // console.log(response)
            dispatch(slice.actions.updateUserGeneralSuccess(response.data.user));

        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function updateUserNotif(input: IUserNotifInput) {
    // console.log(`Update User Notif`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const accessToken = await getAccessToken();
            const response = await axios.post('/user-setting', {
                ...input,
                accessToken,
                type: "notif"
            });
            dispatch(slice.actions.updateUserNotifSuccess(response.data.user));
        } catch (error) {
            // console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function updateUserSocialLink(input: IUserSocialLinkInput) {
    // console.log(`Update User Social Link`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const accessToken = await getAccessToken();
            const response = await axios.post('/user-setting', {
                ...input,
                accessToken,
                type: "socialLink",
            });
            dispatch(slice.actions.updateUserSocialLinkSuccess(response.data.user));
        } catch (error) {
            // console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function updateUserPassword(input: IUserChangePasswordInput) {
    // console.log(`Update User Password`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const accessToken = await getAccessTokenWithRefreshed();
            const response = await axios.post('/user-setting', {
                ...input,
                type: "password",
                accessToken
            });
            dispatch(slice.actions.updateUserPasswordSuccess(response.data.user));
        } catch (error) {
            // console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}